import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import type { ColorType } from "@shared/content-types/schemas/common.schema";
import { BrandIcon } from "@shared/ui/brand-icon";
import { ColorIcon } from "@shared/ui/color-icon";
import type { IconNameType } from "@shared/ui/icon";
import { Body, Heading } from "@shared/ui/typography";

import s from "./info-list-item.module.scss";

export type InfoListItemProps = ComponentProps<"div"> & {
  className?: string;
  title: ReactNode;
  value: ReactNode;
  icon?: {
    name: IconNameType;
    color?: ColorType;
  };
  titleSize?: "uppercase" | "uppercase-small" | "caption" | "special";
  valueLevel?: 1 | 2 | 3 | 4 | 5 | 6;
};

export const InfoListItem = (props: InfoListItemProps) => {
  const {
    className,
    title,
    value,
    icon,
    titleSize = "uppercase-small",
    valueLevel = 6,
    ...rest
  } = props;

  return (
    <div className={clsx(s.root, className)} {...rest}>
      <div className={s.title}>
        {icon?.name && (
          <BrandIcon
            size={16}
            name={icon.name}
            fillColor={icon?.color ?? "violet"}
            strokeColor="milk"
          />
        )}
        <Body tag="span" weight="semiBold" size={titleSize}>
          {title}
        </Body>
      </div>
      <Heading level={valueLevel} tag="h3" className={s.value}>
        {value}
      </Heading>
    </div>
  );
};

InfoListItem.displayName = "InfoListItem";
